// Singleton QueryClient — imported by main.tsx and AuthContext
// Centralised here so AuthContext can call queryClient.clear() on logout/login
// without creating a circular dependency.
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      // Do NOT set a staleTime — data should always be considered stale
      // so it re-fetches after a user switch.
    },
  },
});
